import styles from "./BlogRank.module.scss";
import classNames from "classnames/bind";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faRankingStar } from "@fortawesome/free-solid-svg-icons";
import AllCar from "~/Data";
import { handleHistoryView } from "~/hooks/function";
import { useRef, useState } from "react";
const cx = classNames.bind(styles);
function BlogRank() {
    const [render, setRender] = useState(() => {
        const speedCar = AllCar.filter((e) => e.max > 350);
        speedCar.sort((a, b) => a.max - b.max).reverse();
        const speedRank = speedCar.splice(0, 6);
        return speedRank;
    });
    const [isSpeed, setIsSpeed] = useState(true);
    const mediaQuery = window.matchMedia("(min-width: 768px)").matches;
    const speedRef = useRef();
    const priceRef = useRef();
    const handlePriceRank = (e) => {
        speedRef.current.classList.remove(cx("active"));
        e.target.classList.add(cx("active"));
        let priceCar,
            priceRank = [];
        priceCar = [...AllCar];
        priceCar.sort((a, b) => a.price - b.price).reverse();
        priceRank = priceCar.splice(0, 7);
        console.log(priceRank, "aaaaaaaaaaa");
        setRender(priceRank);
        setIsSpeed(false);
    };
    const handleSpeedRank = (e) => {
        setIsSpeed(true);
        e.target.classList.add(cx("active"));
        priceRef.current.classList.remove(cx("active"));
        const speedCar = AllCar.filter((e) => e.max > 350);
        speedCar.sort((a, b) => a.max - b.max).reverse();
        const speedRank = speedCar.splice(0, 6);
        setRender(speedRank);
    };

    return (
        <>
            {" "}
            <div className={cx("blog_rank")}>
                <h4>
                    {mediaQuery && (
                        <i>
                            <FontAwesomeIcon icon={faRankingStar} />
                        </i>
                    )}{" "}
                    {"  "}Bảng xếp hạng
                </h4>
                <div className={cx("rank_btn")}>
                    <p
                        className={cx("btn_p", "active")}
                        onClick={handleSpeedRank}
                        ref={speedRef}
                    >
                        Tốc độ
                    </p>
                    <p
                        className={cx("btn_p")}
                        ref={priceRef}
                        onClick={handlePriceRank}
                    >
                        Giá trị
                    </p>
                </div>
                {render.map((item, i) => (
                    <Link
                        onClick={() => handleHistoryView(item)}
                        key={i}
                        className={cx("rank_car")}
                        to={item.link}
                    >
                        <span>
                            <img
                                src={item.avatar}
                                alt={item.brand + item.name}
                            />
                        </span>
                        <div className={cx("rank_info")}>
                            <h5>{item.name}</h5>
                            <span>
                                <p className={cx("rank_name")}>{item.brand}</p>
                                <p>
                                    {(isSpeed && `${item.max} Km/h`) ||
                                        `${item.price} Tỷ`}
                                </p>
                            </span>
                        </div>
                        {/* {!mediaQuery && ( */}
                        <div className={cx("rank_right")}>
                            {" "}
                            <FontAwesomeIcon icon={faAngleRight} />
                        </div>
                        {/* )} */}
                    </Link>
                ))}
                {mediaQuery && (
                    <Link to="" className={cx("more_btn")}>
                        Xem thêm 108 chiếc được cập nhật{" "}
                        <span>
                            <FontAwesomeIcon icon={faAngleRight} />
                        </span>
                    </Link>
                )}
            </div>
            {!mediaQuery && (
                <Link to="" className={cx("more_btn")}>
                    Xem thêm 108 chiếc được cập nhật{" "}
                    {/* <span>
                        <FontAwesomeIcon icon={faAngleRight} />
                    </span> */}
                </Link>
            )}
        </>
    );
}

export default BlogRank;
